import { useRoutes } from 'react-router-dom';

// project import
import MainRoutes from './MainRoutes';
import CallbackRoutes from './CallbackRoutes';
import TwinupWorld from './TwinupWorld';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([MainRoutes, CallbackRoutes, TwinupWorld]);
}
